import { createContext } from 'react';
import { useFiltersContext } from '../../../../../Dashboards/Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIA, useChartsData } from '../../../../Common/hooks/useChartsData';
import { subtitlesMap } from '../../../Common/maps/subtitleMap';

export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIA.SERVICES,
            url: 'governanceroom/dashboard/services/indicators'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: data.indicators || [],
              rankingByUnit: data.rankingByUnit || [],
              counterYear: data.counterYear || [],
              selectedYear: data.selectedYear || []
          }
        : {
              indicators: [],
              rankingByUnit: [],
              counterYear: [],
              selectedYear: []
          };

    const subtitlesIndicators = subtitlesMap[
        QUERY_KEYS_SIA.SERVICES
    ].indicators.map((item) => item.type);

    const colors = subtitlesMap[QUERY_KEYS_SIA.SERVICES].indicators.map(
        (item) => item.color
    );

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                subtitles: subtitlesIndicators,
                colors,
                isLoading,
                isError,
                filters,
                module,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
